<script>
    export default {
        data() {
            return {
                form: {
                    name: '',
                    username: '',
                    email: '',
                    password: '',
                    password_confirmation: ''
                },
                feedback: '',
                loading: false,
                errors: {}
            }
        },

        methods: {
            register() {
                this.loading = true;
                axios
                    .post('/register', this.form)
                    .then(({data: {redirect}}) => {
                        location.assign(redirect);
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;

                        this.feedback = 'Some of the data are invalid! Please check the errors!';
                        this.loading = false;
                    })
            },
        }
    }
</script>